import colors from './appColors'

export type ButtonContentColors = {
  text: string
  icon: string
  spinner: string
}

/**
 * Content colors for an ENABLED button filled with `colors.PRIMARY`.
 *
 * `colors.PRIMARY` varies by tenant AND, for Canlan, by PLATFORM (SN-8363).
 * There are three live combinations, and they do NOT agree on content color:
 *
 *   | tenant + platform   | fill      | content         | contrast |
 *   |---------------------|-----------|-----------------|----------|
 *   | SportNinja (both)   | `#F2B400` | dark `#181d26`  | 9.10:1   |
 *   | Canlan — WEB        | `#147efb` | dark `#181d26`  | 4.35:1 ✗ |
 *   | Canlan — MOBILE     | `#004FFF` | WHITE `#FFFFFF` | 5.89:1   |
 *
 * So `PRIMARY_TEXT` is dark in two cases and WHITE in the third. This is why
 * content color must ALWAYS be read from here and never inlined: `#181d26`
 * hardcoded on mobile Canlan renders dark-on-dark-blue at 2.87:1, and white
 * hardcoded anywhere else lands on a bright fill at 1.86:1.
 *
 * Canlan's two primaries resolve through `constants/canlanPrimary.{web,native}.js`,
 * picked by the bundler. A change of primary touches only that file.
 *
 * TODO: Canlan WEB `#147efb` is mid-tone and misses the 4.5:1 AA floor both
 * ways (dark 4.35:1, white 3.88:1); dark is the nearer of two failing options.
 * It needs to go darker (white content) or lighter (dark content) to pass.
 * Mobile's `#004FFF` already passes.
 *
 * Text, icon and spinner are separate fields even though they resolve to the
 * same value within any one build — they are semantically distinct, and
 * consuming them as an object is what keeps icon color from being forgotten
 * at the call site.
 *
 * Only applies to a `colors.PRIMARY` fill. Does NOT apply to disabled buttons
 * (which override the fill away from PRIMARY), outlined/ghost buttons (where
 * PRIMARY is the text color on a transparent background), or `DEFAULT_FLAIR`
 * fills.
 */
export const PRIMARY_BUTTON_CONTENT: ButtonContentColors = {
  text: colors.PRIMARY_TEXT,
  icon: colors.PRIMARY_TEXT,
  spinner: colors.PRIMARY_TEXT,
}

export default PRIMARY_BUTTON_CONTENT
